<template>
	<v-sheet flat>
		<p class="title">Columns: {{ title }}</p>
		<list-options
            class="mb-2"
			:id="id"
			:context="context"
			v-model="question.subquestions"
			@save="save"
			@delete="deleteOption"
		></list-options>
		<v-btn color="primary" @click="save">
			Save Columns
		</v-btn>
	</v-sheet>
</template>

<script>
import ListOptions from "@c/survey/builder/options/ListOptions";

export default {
	name: "EditSubquestions",
	props: {
		id: { type: String },
		context: { type: String },
	},
	data: () => {
		return {
			tab: 0,
			options: [],
			show_more: [],
		};
	},
	computed: {
		title() {
			return this.$store.getters["questions/title"](this.id);
		},
		question() {
			return this.$store.state.questions.data[this.id];
		},
	},
	methods: {
		deleteOption(id) {
			this.$store.dispatch(
				"questions/delete",
				`${this.id}.subquestions.${id}`
			)
		},
		save() {
			const self = this;
			self.$store.dispatch("questions/patch", {
				id: self.id,
				subquestions: self.question.subquestions,
			}).then( () => {
				self.$root.$emit("showToast", "Saved");
			})
		},
	},

	components: {
		ListOptions,
	},
};
</script>
